import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import loadPublications from '../service/publicationApi';
const PAGE_META = {
  '/guides': {
    title: 'Практические руководства',
    type: 'guide'
  },
  '/blogs': {
    title: 'Блоги сообщества',
    type: 'blog'
  },
  '/articles': {
    title: 'Статьи DevConnect',
    type: 'article'
  }
};
export default class PublicationsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    // Маршрут определяет представление, а данные всегда приходят из общего read-only API пакета статей.
    this.meta = PAGE_META[window.location.pathname] || PAGE_META['/articles'];
    this.items = [];
    this.loading = true;
    loadPublications(this.meta.type).then(response => {
      this.items = response.data || [];
    }).catch(() => {
      this.items = [];
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle(this.meta.title);
  }
  view() {
    return m('main.dc-library', {
      'aria-labelledby': 'dc-library-title'
    }, [m('section.dc-library__hero', m('div.dc-container', [m('span.dc-library__eyebrow', 'База знаний DevConnect'), m('h1#dc-library-title', this.meta.title), m('p', 'Разбираем рабочие задачи по шагам: без воды, пересказов документации и непроверенных советов.'), m('nav.dc-library__tabs', {
      'aria-label': 'Виды публикаций'
    }, [this.tab('/articles', 'Статьи', this.meta.type === 'article'), this.tab('/guides', 'Руководства', this.meta.type === 'guide'), this.tab('/blogs', 'Блоги', this.meta.type === 'blog')])])), m('section.dc-container.dc-library__content', m('div.dc-library__grid', this.content()))]);
  }
  content() {
    // Состояния загрузки и пустого каталога сохраняют геометрию страницы и понятны без технических терминов.
    if (this.loading) {
      return m('div.dc-library__empty', [m('h2', 'Загружаем материалы…')]);
    }
    if (!this.items.length) {
      return m('div.dc-library__empty', [m('h2', 'Здесь скоро появятся материалы'), m('p', 'Первую статью или руководство можно создать через обычное обсуждение DevConnect.'), m('a.dc-btn.dc-btn--primary', {
        href: '/all'
      }, 'Начать публикацию')]);
    }
    return this.items.map(item => m('article.dc-publication-card', [m('div.dc-publication-card__cover', {
      style: item.coverUrl ? {
        backgroundImage: `url(${item.coverUrl})`
      } : null
    }, m('span', item.typeLabel)), m('div.dc-publication-card__body', [m('div.dc-publication-card__tags', (item.tags || []).map(tag => m('a', {
      href: `/t/${tag.slug}`
    }, `#${tag.name}`))), m('h2', m('a', {
      href: item.url
    }, item.title)), m('p', item.excerpt || 'Понятный разбор практической задачи с примерами и обсуждением.'), m('footer', [m('span', item.author), m('span', `${item.readingTime} мин · 💬 ${item.comments}`)])])]));
  }
  tab(href, label, active) {
    return m('a', {
      href,
      className: active ? 'is-active' : ''
    }, label);
  }
}
flarum.reg.add('devconnect-articles', 'forum/components/PublicationsPage', PublicationsPage);